(function () {
  'use strict';

  if (window.CzardBoot) return;

  var TASK_TIMEOUT = 12000;
  var GLOBAL_TIMEOUT = 15000;

  var STRICT_TIMEOUT = 60000;
  var strictPending = [];

  var total = 0;
  var settled = 0;
  var sealed = false;
  var pending = [];

  var entries = [];
  var totalWeight = 0;
  var lastProgress = 0;

  function clamp01(v) {
    if (!(v > 0)) return 0;
    return v > 1 ? 1 : v;
  }

  function progress() {
    if (totalWeight <= 0) return sealed ? 1 : lastProgress;

    var sum = 0;
    for (var i = 0; i < entries.length; i++) {
      sum += entries[i].weight * entries[i].fraction;
    }

    var p = clamp01(sum / totalWeight);
    if (p > lastProgress) lastProgress = p;
    return lastProgress;
  }

  function add(promise, label, weight, strict) {
    if (sealed || !promise || typeof promise.then !== 'function') return promise;

    total++;
    var entry = { weight: weight > 0 ? weight : 1, fraction: 0 };
    entries.push(entry);
    totalWeight += entry.weight;

    var timer = 0;

    var guarded = new Promise(function (resolve) {
      var limit = strict ? STRICT_TIMEOUT : TASK_TIMEOUT;
      timer = setTimeout(function () {
        console.warn('[czard-boot] "' + (label || 'task') + '" timed out after ' + limit + 'ms');
        resolve();
      }, limit);

      promise.then(
        function () { resolve(); },
        function (err) {
          console.warn('[czard-boot] "' + (label || 'task') + '" failed:', err);
          resolve();
        }
      );
    }).then(function () {
      if (timer) clearTimeout(timer);
      entry.fraction = 1;
      settled++;
    });

    (strict ? strictPending : pending).push(guarded);
    return promise;
  }

  function task(label, weight, opts) {
    var strict = !!(opts && opts.strict);
    var resolveTask;
    var promise = new Promise(function (res) { resolveTask = res; });
    var entry = null;

    if (!sealed) {
      add(promise, label, weight, strict);
      entry = entries[entries.length - 1];
    }

    return {
      report: function (fraction) {
        if (!entry) return;
        var f = clamp01(fraction);
        if (f > entry.fraction) entry.fraction = f;
      },
      done: function () { resolveTask(); }
    };
  }

  function seal() { sealed = true; }

  function ready() {
    seal();
    var soft = Promise.all(pending.slice());
    var strict = Promise.all(strictPending.slice());
    var ceiling = new Promise(function (resolve) {
      setTimeout(function () {
        if (settled < total) {
          console.warn('[czard-boot] global timeout — releasing the soft tasks with ' + settled + '/' + total + ' ready');
        }
        resolve();
      }, GLOBAL_TIMEOUT);
    });
    return Promise.all([Promise.race([soft, ceiling]), strict]).then(function () {
      lastProgress = 1;
    });
  }

  window.CzardBoot = {
    add: add,
    task: task,
    ready: ready,
    seal: seal,
    progress: progress,
    stats: function () { return { total: total, settled: settled, sealed: sealed }; }
  };
})();
